export const businessSegments = [
  { id: 1, name: 'Paying Customer' },
  { id: 2, name: 'Pilot Customer' },
  { id: 3, name: 'Demo / Test Customer' },
  { id: 4, name: 'Edustore' },
  { id: 5, name: 'Webshop' },
  { id: 6, name: 'Trial' },
  { id: 7, name: 'Freemium personal' },
  { id: 9, name: 'Sponsored game user'},
  { id: 10, name: 'New Player License model'}
];



// WEBPACK FOOTER //
// ./src/segments/data.js